import http, { endpoints } from '../http'
import { INewsDto } from './dtos'
import { mapNewsFromDto } from './helpers'
import { INews } from './models'

const datahubClient = http.createClient(`${endpoints.datahub}`)

export default class NewsApi {
	static async getTopThreeNews(locale: string) {
		let language = 'EN'

		if (locale.includes('da') || locale.includes('dk')) language = 'DA'
		if (locale.includes('sv') || locale.includes('se')) language = 'SV'
		if (locale.includes('no')) language = 'NO'
		if (locale.includes('vi')) language = 'VI'

		const response = await datahubClient.get<INewsDto[]>(`/news/language/${language}?numberOfNews=3`)

		return response?.data?.map(mapNewsFromDto) || []
	}

	static async getNewsById(id: INews['id'], locale: string) {
		const allNews = await this.getTopThreeNews(locale)
		return allNews.find(news => news.id === id)
	}
}
